import { render, staticRenderFns } from "./exam_ksxx.vue?vue&type=template&id=5194da5c&scoped=true&"
import script from "./exam_ksxx.vue?vue&type=script&lang=js&"
export * from "./exam_ksxx.vue?vue&type=script&lang=js&"
import style0 from "./exam_ksxx.vue?vue&type=style&index=0&id=5194da5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5194da5c",
  null
  
)

export default component.exports